//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {ImagePreview} from "vant";
import {formatDate} from "../../../src/lib/date";
import util from "@/lib/util";

export default {
    name: "onSale",
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, "yyyy-MM-dd");
            }
            return formatDate(date, "yyyy-MM-dd hh:mm");
        }
    },
    data() {
        return {
            louShuInfo: {},
            id: 0,
            downloadUrl: util.ApiUrl + "/file/download/",
            huXingList: [],
            baiduUrl: 'https://apis.map.qq.com/uri/v1/search?keyword='
        };
    },
    methods: {
        swiperImgClick(imgs) {
            var l = [];
            for (var i = 0; i < imgs.length; i++) {
                var url = this.downloadUrl + imgs[i];
                l.push(url);
            }
            ImagePreview(l);
        },
        getLouShu() {
            abp.ajax
                .get("/api/services/app/LouShu/GetLouShuById?id=" + this.id)
                .then(res => {
                    if (res.data.result != null) {
                        this.louShuInfo = {};
                        this.louShuInfo = res.data.result;
                        this.getHuXingList(this.louShuInfo.id);
                    }
                });
        },
        getHuXingList(lid) {
            abp.ajax
                .post("/api/services/app/LouShu/HuXingList?louShuId=" + lid)
                .then(res => {
                    this.huXingList = [];
                    this.huXingList.push(...res.data.result.items);
                })
                .finally(() => {
                });
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getLouShu();
        }
    }
};
